import { render, staticRenderFns } from "./ParametrosAccion.vue?vue&type=template&id=f1d4e0d0&scoped=true&"
import script from "./ParametrosAccion.vue?vue&type=script&lang=js&"
export * from "./ParametrosAccion.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosAccion.vue?vue&type=style&index=0&id=f1d4e0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d4e0d0",
  null
  
)

export default component.exports